import { Facets, QueryValues } from '@/types/algonomy';
import { AlgonomyBaseService } from './service';
import { SearchParams } from '../../service';
import { filterQuerypattern, mappedCustomFilters } from '../RangeFilterStrategy/types';

class AlgonomyBase implements AlgonomyBaseService {
  // detects if filter query string is a range filter
  public isRangeFilter(facet: string): boolean {
    const facetLower = facet.toLowerCase();
    return (
      facetLower.includes('effectivepricerange') ||
      facetLower.includes('velocityrange') ||
      facetLower.includes('ratingrange') ||
      facetLower.includes('projectileweightrange') ||
      facetLower.includes('ammoweightrange')
    );
  }

  // parsing filter query in order to get facet name and value
  public parseFilterQuery(filterQuery: string): Record<string, string> {
    const match = filterQuery.match(/\{!tag=(.*?)\}(.+):"(.*)"$/);
    if (match) {
      const tagValue = match[1];
      const paramValue = this.replaceSlash(match[3]);

      return { [tagValue]: paramValue };
    }

    return {};
  }

  public parseRangeFilterquery(filterQuery: string, filterValue: string): Record<string, string> {
    const matches = filterQuerypattern.exec(filterQuery);
    if (matches) {
      if (matches.length >= 3) {
        // corner case because we have price in url params not product_effective_price
        const tag = matches[1];
        const mappedTag = mappedCustomFilters[tag];
        return { [tag]: mappedTag[filterValue.replace(/\\/g, '')] };
      }
    }

    return {};
  }

  public getCurrentUrl(headers: Headers) {
    const protocol = headers.get("x-forwarded-proto") || "https";
    const host = headers.get("x-forwarded-host") || headers.get("host");

    return `${protocol}://${host}`;
  }

  public getPrefUrl(headers: Headers, searchParams: SearchParams) {

    const domain = this.getCurrentUrl(headers)
    const pathname = headers.get("x-current-path");
    const queryString = new URLSearchParams(searchParams.filters as string);
    return `${domain}${pathname}${queryString.toString().replace(/[^a-z0-9\-_\.]/g, "")}`;
  }

  public getUtmValues(searchParams: SearchParams, headers: Headers | null): string | null {
    const filters = (searchParams as SearchParams).filters || (searchParams as SearchParams) || {};

    const utmMedium = Object.keys(filters).includes('utm_medium');

    if (utmMedium) {
      return filters['utm_medium']
    }

    if (!utmMedium && headers && this.getCurrentUrl(headers) !== 'https://stage.pyramydair.com' && this.getCurrentUrl(headers) !== 'https://wwww.pyramydair.com') {
      return headers.get('referer')?.replace(/[^a-z0-9\-_\.]/g, "") || null;
    }

    return null
  }

  protected getFilterValues(queryObject: QueryValues | SearchParams): QueryValues {
    const { keyword, sort, start, viewOption, rows, shallow, pg, sid, q, Ntt, ntt, utm_source, utm_medium, sgs, utm_campaign, ...queryParamObject } = queryObject;
    return queryParamObject as QueryValues;
  }

  protected getSelectedFiltersAmount(facets: Array<Facets>): number {
    return (
      facets
        ?.map((filter: Facets) => {
          return filter.values.filter((value) => value.selected);
        })
        ?.flat()?.length || 0
    );
  }

  // util function whic replace slash in algonomy query
  // ex. '{!tag=ProductStatus}ProductStatus:"in\\-stock"' will become '{!tag=ProductStatus}ProductStatus:"in-stock"'
  private replaceSlash(filterValue: string): string {
    return filterValue.replace(/\\/g, '');
  }
}

export default AlgonomyBase;
